import {DOT_PATTERN_BOUNDS,DOT_TILE_SIZE,normalizeDotPattern,dotPatternTile,dotPatternMask} from './dot-pattern.js';

export default function DotPattern({layer,prefix}) {
  const id=`${prefix}dots${layer.id}`,maskId=`${id}removed`,state=normalizeDotPattern(layer);
  const {removed,restored}=dotPatternMask(layer),bounds=DOT_PATTERN_BOUNDS;
  const tileCoordinates=(center,radius)=>[-DOT_TILE_SIZE,0,DOT_TILE_SIZE].map(offset=>center+offset).filter(value=>value+radius>0&&value-radius<DOT_TILE_SIZE);
  return <g data-dot-density={state.dotDensity} data-dot-size={state.dotSize} transform={state.dotFlipX?'translate(100 0) scale(-1 1)':undefined}>
    <defs>
      <pattern id={id} width={DOT_TILE_SIZE} height={DOT_TILE_SIZE} patternUnits="userSpaceOnUse">
        {dotPatternTile(state.dotDensity,state.dotSize).flatMap((dot,index)=>tileCoordinates(dot.x,dot.r).flatMap(x=>tileCoordinates(dot.y,dot.r).map(y=><circle key={`${index}:${x}:${y}`} cx={x} cy={y} r={dot.r} fill={layer.color}/>)))}
      </pattern>
      {removed.length>0&&<mask id={maskId} maskUnits="userSpaceOnUse" {...bounds}>
        <rect {...bounds} fill="white"/>
        {removed.map(dot=><circle key={dot.id} cx={dot.x} cy={dot.y} r={dot.r+.15} fill="black"/>)}
        {restored.map(dot=><circle key={`keep-${dot.id}`} cx={dot.x} cy={dot.y} r={dot.r} fill="white"/>)}
      </mask>}
    </defs>
    <rect {...bounds} fill={`url(#${id})`} mask={removed.length?`url(#${maskId})`:undefined}/>
  </g>;
}
